import SearchPage from './SearchPage.vue';

export default [
  {
    path: '/search',
    name: 'search',
    component: SearchPage,
    meta: {
      title: 'Recherche'
    }
  }
];
